<template>
  <el-dialog
      v-if="visible"
      :visible.sync="visible"
      width="400px"
      height="500"
  >
    <el-descriptions :column="1" :colon=false title="亲属关系明细：" direction="vertical">
      <span style="font-size: 15px;font-weight: bold">亲属关系明细：</span> <br>
      <template v-for="(item,index) in options">
        <el-descriptions-item :key="index"><span style="font-size: 12px;">{{item.code}}</span>:
         <span style="font-size: 12px;font-weight: bold">{{item.extText1}}</span> <br></el-descriptions-item>
      </template>
    </el-descriptions>
    <template>
      <div class="button-container">
        <el-button @click="visible = false" type="primary">关闭</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>

export default {
  name:'showArchivedType',
  data() {
    return {
      visible: false,
      options:[
          {code:"（一）",extText1:"夫妻关系"},
          {code:"（二）",extText1:"直系血亲关系,包括祖父母、外祖父母、父母、孙子女、外孙子女"},
          {code:"（三）",extText1:"三代以内旁系血亲关系，包括叔伯姑舅姨、兄弟姐妹、堂兄弟姐妹、表兄弟姐妹、侄子女、甥子女"},
          {code:"（四）",extText1:"近姻亲关系，包括配偶的父母、配偶的兄弟姐妹及其配偶、子女的配偶及子女配偶的父母"},
          {code:"（五）",extText1:"其他亲属关系，包括养父母子女，形成抚养关系的继父母子女及由此形成的直系血亲、三代以内旁系血亲和近姻亲关系"},
      ],
    }
  },
  methods: {
   async open(){

      this.visible=true
    },
  },
  mounted() {
  },
}
</script>

<style scoped lang="scss">
.val {
  white-space: nowrap;
}
.disabled{
  ::v-deep .el-input__inner {
    border: none;
    background: transparent;
    color: #222222;
    cursor: auto!important;
    padding: 0;
  }
  ::v-deep .el-input__suffix{
    display: none;
  }
}
.button-container {
  margin-top: 10px;
  text-align: center;
}
</style>
